module.exports = __webpack_public_path__ + "static/media/icon-slide.4ac5a46b.svg";